
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import { isSome } from '@mbfab/shared'
import { Button, Checkbox, Input, message, Popconfirm, Space } from 'antd'
import type { FilterDropdownProps } from 'antd/lib/table/interface'
import type { Dispatch, SetStateAction } from 'react'
import React, { useRef, useState } from 'react'

export function createDestroyColumn<T>(
  loading: boolean,
  setLoading: Dispatch<SetStateAction<boolean>>,
  onDestroy: (record: T) => Promise<void>,
  condition?: (x: T) => boolean,
) {
  return {
    title: '',
    key: 'destroy' as const,
    width: 20,
    render(_text: unknown, record: T) {
      const confirm = async () => {
        try {
          setLoading(true)
          await onDestroy(record)
          void message.success(`削除しました`)
        } catch (e) {
          // TODO
          if (e instanceof Error) {
            void message.error(`削除に失敗しました。${e.message}`)
          } else {
            void message.error(`削除に失敗しました。`)
          }
          throw e
        } finally {
          setLoading(false)
        }
      }

      if (condition !== undefined && !condition(record)) {
        return <></>
      }

      return (
        <Popconfirm
          title={`本当に削除しますか?`}
          onConfirm={confirm}
          okText={`はい`}
          cancelText={`いいえ`}
          okButtonProps={{ loading }}
          onPopupClick={(e) => {
            e.stopPropagation()
          }}
        >
          <Button
            type="text"
            icon={<DeleteOutlined />}
            onClick={(e) => {
              e.stopPropagation()
            }}
          ></Button>
        </Popconfirm>
      )
    },
  }
}

export function getColumnSearchProps<T>(recordToValue: (record: T) => string) {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: FilterDropdownProps) => {
      const ref = useRef(null)

      // 正しい方法ではなさそうだが、これ以外でfocusできなかった
      setTimeout(() => {
        const current: any = ref.current
        if (isSome(current)) {
          current.focus()
        }
      }, 200)

      return (
        <div style={{ padding: 8 }}>
          <Input
            ref={ref}
            // placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value === undefined ? [] : [e.target.value])
              confirm({ closeDropdown: false })
            }}
            onPressEnter={(e) => {
              confirm({ closeDropdown: true })
            }}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            {/* <Button
            type="primary"
            onClick={(e) => { confirm({ closeDropdown: true }) }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            検索
          </Button> */}
            <Button
              onClick={(e) => {
                if (clearFilters !== undefined) {
                  clearFilters()
                }
                confirm()
              }}
            >
              {`リセット`}
            </Button>
          </Space>
        </div>
      )
    },
    filterIcon: (filtered: boolean) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,

    onFilter: (value: unknown, record: T) =>
      recordToValue(record)
        ?.toLowerCase() // ?.は不要なはずだが、実装ミスでこれがありえるようなので追加
        ?.includes(typeof value === 'string' ? value.toLowerCase() : (value as string)),
  }
}

export function getColumnFilterDropdownProps<T>(options: Array<{ value: string; label: string }>) {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: FilterDropdownProps) => {
      const [keys, setKeys] = useState(selectedKeys)

      return (
        <div
          className="px-2 py-2"
          style={{
            maxWidth: 400,
            overflowX: 'auto',
          }}
        >
          <Checkbox
            onChange={() => {
              if (keys.length === options.length) {
                setKeys([])
              } else {
                setKeys(options.map((x) => x.value))
              }
            }}
            checked={keys.length === options.length}
          />
          <hr className="m-0 my-1 opacity-20" />
          <div
            style={{
              maxHeight: 254,
              overflow: 'auto',
            }}
          >
            {options.map((option) => {
              return (
                <>
                  <Checkbox
                    onChange={(value) => {
                      if (value.target.checked) {
                        setKeys([...keys, option.value].unique())
                      } else {
                        setKeys([...keys].filter((key) => key !== option.value))
                      }
                    }}
                    checked={keys.includes(option.value)}
                  >
                    {option.label}
                  </Checkbox>
                  <br />
                </>
              )
            })}
          </div>
          <hr className="m-0 my-1 opacity-20" />
          <Space className="mt-2 flex justify-end">
            <Button
              onClick={() => {
                if (clearFilters !== undefined) {
                  clearFilters()
                }
                setKeys([])
                confirm()
              }}
              type="text"
              size="small"
            >
              {`クリア`}
            </Button>
            <Button
              onClick={() => {
                setSelectedKeys(keys)
                confirm()
              }}
              type="primary"
              size="small"
            >
              {`決定`}
            </Button>
          </Space>
        </div>
      )
    },
  }
}
